import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { parse } from "tldts";
import "../css/TeamsPage.css";
import "../css/Navbar.css";

const TeamsPage = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  const [menuOpen, setMenuOpen] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [applyNowOpen, setApplyNowOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const [company, setCompany] = useState({
    name: "Your Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    superAdminId: "",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);

    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
  const loadCompany = async () => {
    try {
      const { domain } = getDomainInfo();

      const response = await axios.get(
        "https://payyug.in/api/get-company",
        {
          params: { domain },
        }
      );

      const data = response.data;

      if (data) {
        setCompany(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  loadCompany();
}, []);

  useEffect(() => {
    if (company.superAdminId) {
      fetchTeams(company.superAdminId);
    }
  }, [company.superAdminId]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const fetchTeams = async (superAdminId) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `https://payyug.in/api/get-all-team?superAdminId=${superAdminId}`
      );

      console.log(response.data);

      if (response.data.success) {
        setTeams(response.data.teamMembers || []);
      }
    } catch (error) {
      console.error("Error fetching teams:", error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (photo) => {
    if (!photo) {
      return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    }

    return `https://payyug.in/${photo}`;
  };

  const getLogoUrl = (path) => {
    if (!path) return "";

    const cleanPath = path.startsWith("images/")
      ? path.slice(7)
      : path;

    return `https://payyug.in/${cleanPath}`;
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 960) {
      setMenuOpen(false);
      setLoginDropdownOpen(false);
      setApplyNowOpen(false);
    }
  };

  return (
    <div className="teams-page">

      {/* HEADER */}

      <header className={`hp-header ${scrolled ? "hp-header-scrolled" : ""}`}>

        {/* LOGO */}

        <div className="hp-navbar-logo-area">
          {company.logo ? (
            <img
              src={getLogoUrl(company.logo)}
              alt={company.name}
            />
          ) : (
            <div className="hp-fallback-logo">
              {company.name}
            </div>
          )}
        </div>

        {/* NAVBAR */}

        <nav className={`hp-navbar-nav-links ${menuOpen ? "hp-navbar-mobile-open" : ""}`}>
          <Link to="/" onClick={handleLinkClick}>Home</Link>
          <Link to="/about" onClick={handleLinkClick}>About Us</Link>
          <Link to="/service" onClick={handleLinkClick}>Service</Link>
          <Link to="/teams" onClick={handleLinkClick}>Team</Link>
          <Link to="/legal-documents" onClick={handleLinkClick}>Legal Documents</Link>
          <Link to="/support" onClick={handleLinkClick}>Contact</Link>
        </nav>

        {/* BUTTONS */}

        <div className="hp-navbar-buttons">

          {/* APPLY NOW */}

          <div className={`hp-navbar-dropdown ${applyNowOpen ? "hp-navbar-open" : ""}`}>

            <button
              type="button"
              className="hp-navbar-apply-btn"
              onClick={() => setApplyNowOpen(!applyNowOpen)}
            >
              Apply Now
            </button>

            {applyNowOpen && (
              <div className="hp-navbar-dropdown-content">
                <Link to="/personal-loan">
                  Loan Account
                </Link>
              </div>
            )}
          </div>

          {/* LOGIN */}

          <div className={`hp-navbar-dropdown ${loginDropdownOpen ? "hp-navbar-open" : ""}`}>

            <button
              type="button"
              className="hp-navbar-login-btn"
              onClick={() => setLoginDropdownOpen(!loginDropdownOpen)}
            >
              Login
            </button>

            {loginDropdownOpen && (
              <div className="hp-navbar-dropdown-content">
                <Link to="/login">Admin Login</Link>
                <Link to="#">Branch Login</Link>
              </div>
            )}
          </div>
        </div>

        {/* MOBILE MENU */}

        <div
          className={`hp-navbar-hamburger ${menuOpen ? "hp-navbar-open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </header>

      {/* HERO */}

      <section className="teams-hero">
        <div className="teams-overlay">
          <h1>Meet Our Team</h1>

          <p>
            Our dedicated professionals work passionately to deliver
            trusted financial solutions and customer satisfaction.
          </p>
        </div>
      </section>

      {/* TEAM SECTION */}

      <section className="teams-section">

        <div className="teams-container">

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader"></div>
              <p>Loading Team Members...</p>
            </div>
          ) : teams.length === 0 ? (
            <div className="empty-state">
              <h2>No Team Members Found</h2>
            </div>
          ) : (
            <div className="teams-grid">

              {teams.map((member) => (
                <div className="team-card" key={member.id}>

                  {/* IMAGE */}

                  <div className="team-image-box">
                    <img
                      src={getImageUrl(member.photo)}
                      alt={member.name}
                      className="team-image"
                    />
                  </div>

                  {/* CONTENT */}

                  <div className="team-content">

                    <h2>{member.name}</h2>

                    <span className="designation">
                      {member.designation}
                    </span>

                    {/* SOCIALS */}

                    <div className="social-links">

                      {member.linkedin && (
                        <a
                          href={
                            member.linkedin.startsWith("http")
                              ? member.linkedin
                              : `https://${member.linkedin}`
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      )}

                      {member.instagram && (
                        <a
                          href={
                            member.instagram.startsWith("http")
                              ? member.instagram
                              : `https://${member.instagram}`
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      )}

                      {member.facebook && (
                        <a
                          href={
                            member.facebook.startsWith("http")
                              ? member.facebook
                              : `https://${member.facebook}`
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      )}

                      {member.twitter && (
                        <a
                          href={
                            member.twitter.startsWith("http")
                              ? member.twitter
                              : `https://${member.twitter}`
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fab fa-x-twitter"></i>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* FOOTER */}

      <footer className="teams-footer">
        <p>
          © 2026 {company?.name || "Techvision Demo Software"}.
          All rights reserved.
        </p>

        <span>
          Design & Developed by TechVision
        </span>
      </footer>
    </div>
  );
};

export default TeamsPage;